import {capitalize} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import React from 'react';
import {OpinionCard} from '../OpinionCard';
import {OpinionCardsGridType} from './types';

export const OpinionCardsGrid = React.memo(({list}: OpinionCardsGridType) => (
	<StyledGrid.Root spacing={2}>
		{list?.map((card, index) => (
			<StyledGrid.Item key={index} xs={12} sm={12} md={12} lg={4} xl={4}>
				<OpinionCard
					specialtyName={capitalize(card.specialtyName.toLowerCase())}
					date={`${card.opinionDate} às ${card.opinionTime}`}
					dataTestId={`opinion-card-${index + 1}`}
				/>
			</StyledGrid.Item>
		))}
	</StyledGrid.Root>
));
